import * as yup from 'yup'

export const ValidationSchemaReportsAndDocument = yup.object().shape({
  cooperative_name: yup.string().max(150, 'Máximo de 150 caracteres.')
})
